import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

export default function TenantSelector() {
  const navigate = useNavigate();
  const [tenantSlug, setTenantSlug] = useState('');

  // Tenants disponibles conocidos
  const knownTenants = [
    { slug: 'demo-corp', name: 'Demo Corporation', description: 'Ambiente de demostración' },
    { slug: 'rototec-sa-de-cv', name: 'Rototec S.A. de C.V.', description: 'Empresa productiva' }
  ];

  const handleContinue = () => {
    if (tenantSlug.trim()) {
      navigate(`/${tenantSlug.toLowerCase().replace(/\s+/g, '-')}/login`);
    }
  };

  const handleSelectTenant = (slug: string) => {
    navigate(`/${slug}/login`);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex justify-center">
          <img src="/qpulse-logo.png" alt="QPulseMES" className="w-20 h-20 object-contain" />
        </div>
        <h2 className="mt-6 text-center text-3xl font-bold text-gray-900">
          Selecciona tu organización
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Para continuar, ingresa el nombre de tu organización o selecciona una de las disponibles
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          
          {/* Input manual */}
          <div className="mb-6">
            <label htmlFor="tenant" className="block text-sm font-medium text-gray-700 mb-2">
              Nombre de tu organización
            </label>
            <div className="space-y-3">
              <Input
                id="tenant"
                type="text"
                placeholder="ej: mi-empresa"
                value={tenantSlug}
                onChange={(e) => setTenantSlug(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleContinue()}
                className="block w-full"
              />
              <Button 
                onClick={handleContinue}
                disabled={!tenantSlug.trim()}
                className="w-full bg-blue-600 hover:bg-blue-700"
              >
                Continuar
              </Button>
            </div>
          </div>

          {/* Separador */}
          <div className="relative my-6">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-300" />
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-2 bg-white text-gray-500">O selecciona una organización</span>
            </div>
          </div>

          {/* Organizaciones conocidas */}
          <div className="space-y-3">
            {knownTenants.map((tenant) => (
              <button
                key={tenant.slug}
                onClick={() => handleSelectTenant(tenant.slug)}
                className="w-full text-left p-4 border border-gray-200 rounded-lg hover:border-blue-300 hover:bg-blue-50 transition-colors"
              >
                <div className="font-medium text-gray-900">{tenant.name}</div>
                <div className="text-sm text-gray-500">{tenant.description}</div>
              </button>
            ))}
          </div>

          {/* Link de regreso */}
          <div className="mt-6 text-center">
            <button
              onClick={() => navigate('/')}
              className="text-sm text-blue-600 hover:text-blue-500"
            >
              ← Regresar al inicio
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}